import type { InferOutput } from "valibot";
import { object } from "valibot";
import { initIntegrationDefinition } from "../Integration";
import { useTranslation } from "../../state/i18n";
import { NumberInput } from "../../components/inputs/NumberInput";
import type { IncompleteIntegrationDefinition } from "../types";
import { integerValue } from "../../utils/validation/base";
import { integrationsIcons } from "../IntegrationIcons";
import { keyFromSelector } from "i18next";

const DELAY_MIN_DAYS = 0;
const DELAY_MAX_DAYS = 1827;

type ConfigurationDto = {
  delay: number;
};

const Schema = object({
  delay: integerValue(DELAY_MIN_DAYS, DELAY_MAX_DAYS),
});

export type DeleteIntegrationConfiguration = InferOutput<typeof Schema>;
const DeleteIntegration: IncompleteIntegrationDefinition<DeleteIntegrationConfiguration, ConfigurationDto> = {
  type: "delete",
  legacy: {
    namespace: "com.moreapp",
    key: "delete",
    version: 6,
  },
  schema: Schema,
  icon: integrationsIcons["delete"],
  titleKey: keyFromSelector(($) => $.DELETE_INTEGRATION_TITLE),
  descriptionKey: keyFromSelector(($) => $.DELETE_INTEGRATION_DESCRIPTION),
  defaultProperties: () => ({ delay: undefined }),
  limit: 1,
  propertyKeys: {
    delay: keyFromSelector(($) => $.DELETE_INTEGRATION_CONFIGURATION_DELAY_LABEL),
  },
  fromDto: (configuration) => ({ delay: configuration.delay }),
  toDto: (configuration) => configuration,
  EditItem: (props) => {
    const { t } = useTranslation();

    return (
      <>
        <NumberInput
          label={t(props.propertyKeys.delay)}
          value={props.integration.configuration.delay}
          minValue={DELAY_MIN_DAYS}
          maxValue={DELAY_MAX_DAYS}
          onBlur={(value) => props.updateConfiguration("delay", value)}
          errorMessage={props.getError("delay")}
          required
          info={{
            title: t(props.propertyKeys.delay),
            alt: t(($) => $.INTEGRATIONS_PROPERTY_DESCRIPTION_ARIA_LABEL, { property: props.propertyKeys.delay }),
            description: t(($) => $.DELETE_INTEGRATION_CONFIGURATION_DELAY_DESCRIPTION),
          }}
        />
      </>
    );
  },
};

export default initIntegrationDefinition(DeleteIntegration);
